import React, { useState, useEffect } from "react";
import ReceiptsHistory from "./components/ReceiptsHistory";

import WithdrawalsTable from "./components/WithdrawalsTable";
import ConnectedAccount from "./components/ConnectedAccount";
import FundsProjection from "./components/FundsProjection";

import Taxes from "./components/Taxes";
import RequestWithdrawalModal from "@components/_modals/Billing/RequestWithdrawalModal";
import api from "@helpers/api.js";

import { useParams, useNavigate } from "react-router-dom";
import { Text } from "@fragments";
import { IconWallet } from "@tabler/icons-react";

import "./styles.scss";

export default function WithdrawalSection() {
    const [loading, setLoading] = useState(true);
    const [wallet, setWallet] = useState(null);
    const REF_modal = React.useRef();
    const { action } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        handleLoad();
    }, []);

    useEffect(() => {
        if (action === 'request' && REF_modal.current && wallet && !loading) {
            navigate('/banking/withdrawal', { replace: true });
            REF_modal.current.open({ wallet, amount: parseInt(wallet?.balance?.available) }, handleLoad);
        }
    }, [action, wallet, loading]);

    async function handleLoad() {
        try {
            const { data } = await api.get("wallet");
            setWallet(data);
        } catch (e) {
            console.log(e);
        }
        setLoading(false);
    }

    function handleRegisterAccount() {
        if (REF_modal.current) {
            REF_modal.current.open({ configureOnly: true }, handleLoad);
        }
    }

    return (
        <div>
            {/*<ReceiptsHistory />*/}
            <Text.h3 weight={500} className="mt-3" left={<IconWallet />}>
                Informações da wallet
            </Text.h3>
            <div className="wallet-info">
                <ConnectedAccount
                    wallet={wallet}
                    loading={loading}
                    onRegisterAccount={handleRegisterAccount}
                />
                <Taxes wallet={wallet} loading={loading} />
            </div>
            <WithdrawalsTable />
            <FundsProjection />
            <RequestWithdrawalModal modalRef={REF_modal} />
        </div>
    )
}
